<div style="height: 550px;">
  <form [formGroup]="SettingsForm">
    <div class="row">
      <fieldset>
        <legend>Basic Settings</legend>
      </fieldset>
    </div>
    <div class="row">
      <div class="uv-row">
        <div class="col-lg-1">
          <span>Name:</span>
        </div>
        <input type="text" pInputText style="width: 250px;" class="ms-2 me-5" [formControl]="name" />
        <div class="col-lg-2">
          <input type="checkbox" [formControl]="enabled" />
          <span class="uv-checkbox-label">Enabled</span>
        </div>
      </div>
    </div>
    @if (name.hasError('required')) {
      <div class="row">
        <div class="uv-row">
          <div class="col-lg-1">&nbsp;</div>
          <div class="alert alert-danger ms-2" style="width: 250px;">
            This value is required
          </div>
        </div>
      </div>
    }
    <div class="mb-3"></div>
    <div class="mb-3 row">
      <div class="col-lg-3">
        <input id="verifyDown" type="checkbox" class="snmpif-checkbox-control" [formControl]="verifyDown" />
        <span class="uv-checkbox-label">Verify OperStatus = DOWN</span>
      </div>
    </div>
    <div class="row">
      <fieldset>
        <legend>Monitor Thresholds / Interface Utilization</legend>
      </fieldset>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-6">
        <input type="checkbox" class="snmpif-checkbox-control" [formControl]="useThresholds"
          (change)="enableDisableControls()" />
          <span class="uv-checkbox-label">Use Utilization Thresholds</span>
        </div>
      </div>
      <div class="row">
        <div class="uv-row">
          <div class="col-lg-1">
            <span>Critical:</span>
          </div>
          <div class="col-lg-5">
            <input type="number" pInputText style="width: 85px;" [formControl]="criticalThreshold" />
            <span style="margin-left: 10px;">(>= Utilization enters critical state)</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="uv-row">
          <div class="col-lg-1">&nbsp;</div>
          @if (criticalThreshold.hasError('required')) {
            <div class="alert alert-danger">
              This value is required
            </div>
          }
          @if (criticalThreshold.hasError('minValue') || criticalThreshold.hasError('maxValue')) {
            <div
              class="alert alert-danger">
              This value must be in the range 100 - 1000000
            </div>
          }
        </div>
      </div>
      <div class="mb-3"></div>
      <div class="row">
        <div class="uv-row">
          <div class="col-lg-1">
            <span>Warning:</span>
          </div>
          <div class="col-lg-5">
            <input type="number" pInputText style="width: 85px;" [formControl]="warningThreshold" />
            <span style="margin-left: 10px;">(>= Utilization enters warning state)</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="uv-row">
          <div class="col-lg-1">&nbsp;</div>
          @if (warningThreshold.hasError('required')) {
            <div class="alert alert-danger">This value is required
            </div>
          }
          @if (warningThreshold.hasError('minValue') || warningThreshold.hasError('maxValue')) {
            <div
            class="alert alert-danger">This value must be in the range 0 - 1000000</div>
          }
          @if (SettingsForm.hasError('validThresholds')) {
            <div class="alert alert-danger">The critical threshold
            cannot be less than the warning threshold</div>
          }
        </div>
      </div>
    </form>
  </div>
